import IntegrationCallStepPagingResultModelBase from '../_generated/modelBases/integration-call-step-paging-result-model-base';

export default class IntegrationCallStepPagingResultModel extends IntegrationCallStepPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
